import axios from 'axios';

const vrtApiRequest = axios.create({
    baseURL: process.env.REACT_APP_VRT_API,
    headers: {
        'Content-Type': 'application/json',
        'client':'10xj5LS9ECqWkWdWTrxA'
    }
});

export {
    vrtApiRequest,
}
